export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'fle';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'fle-citsoa@tcestrela.com.br';
export const password = 'h2uX8C$Pem';

export const versaoSoftware = '4.4.19';
export const idioma = 'pt_BR'

export default {
}